import buildRoute from './buildRoute'

export const getTelemetry = async (filters: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'get-telemetry',
            data: filters,
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const getBoatTelemetry = async ({ deviceSerial, keys, startTime, endTime }: { deviceSerial: any; keys: any; startTime?: any; endTime?: any }) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'get-boat-telemetry',
            data: { deviceSerial, keys, ...(startTime && endTime && { startTime, endTime }) },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const getBoatDTCs = async ({ deviceSerial, limit = 50 }) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'get-boat-dtcs',
            data: { deviceSerial, limit },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const getBoatAlarms = async ({ deviceSerial, limit = 50 }) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'get-boat-alarms',
            data: { deviceSerial, limit },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const getBoatStatus = async ({ deviceSerial, limit = 100 }) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'get-boat-status',
            data: { deviceSerial, limit },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const getAvailableVariables = async (deviceSerial: string) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'get-available-variables',
            data: { deviceSerial },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const getTripsForBoat = async ({ deviceSerial, limit = 5 }) => {
    try {
        // console.log('=== API CALL START ===')
        // console.log('API: Calling getTripsForBoat with:', { deviceSerial, limit })
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'get-boat-trips',
            data: { deviceSerial, limit },
        })
        // console.log('=== API RESPONSE ===')
        // console.log('API: Response from buildRoute:', res)
        // console.log('API: Response status:', res?.status)
        // console.log('API: Response data:', res?.data)
        if (res.data) {
            return res.data
        }
        console.log('=== API NO DATA ===')
        return res
    } catch (err: any) {
        console.log('=== API ERROR ===')
        console.error('API: Error in getTripsForBoat:', err)
        console.error('API: Error response:', err.response?.data)
        console.error('API: Error status:', err.response?.status)
        console.error('API: Error config:', err.config)
        return err
    }
}

export const getTripGPSData = async ({ deviceSerial, tripStart, tripEnd }) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'get-trip-gps-data',
            data: { deviceSerial, tripStart, tripEnd },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const getTripTelemetryData = async ({ deviceSerial, tripStart, tripEnd, variables = [] }) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'get-trip-telemetry-data',
            data: { deviceSerial, tripStart, tripEnd, variables },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const getEngineVariables = async (deviceSerial: string) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'get-engine-variables',
            data: { deviceSerial },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error('Error fetching engine variables:', err)
        return err
    }
}
